// Investigation Assistance Page Translation
export default {
  title: "Investigation Assistance",
  tips: {
    investigationInfo: "Investigation Information",
    investigationLimit:
      "(It is recommended not to exceed 10 queries per investigation to avoid long response times)",
  },
  form: {
    platformType: "Platform Type (Required)",
    operationType: "Operation Type (Required)",
    selectPlatform: "Select Platform (Required)",
    priority: "Investigation Priority",
    addressInfo: "Address Information",
    addressVerify: "Address Verification",
    withdrawHash: "Withdrawal Hash",
    hashVerify: "Hash Verification",
    identityInfo: "Identity Information",
    identityVerify: "Identity Verification",
    remark: "Remark",
    relatedCase: "Related Case",
  },
  placeholders: {
    selectPlatformType: "Select platform type",
    selectOperationType: "Select operation type",
    selectPlatform: "Select platform",
    selectInstitution: "Select institution",
    selectChain: "Enter chain",
    selectCase: "Select case",
    addressInfo: `Enter transaction addresses, separate multiple addresses with line breaks, max 50 addresses
Example:
TNUC9Qb1rRpS5CbWLmNMxXBjyFoydXjWFR
TSUUVjysXV8YqHytSNjfkNXnnB49QDvZpx`,
    hashInfo: `Enter withdrawal hashes, separate multiple hashes with line breaks, max 50 hashes
Example:
c45ee90b9e5d850ac799740d6137b5b9f52e26e51ead132e459f5fc06fc89b73
b556473f9030cf2c1bb176f5aad11786419c41aff865a710b0a0d20976617df2`,
    identityInfo: `Enter identity information, separate multiple entries with line breaks, max 50 entries
Example:
Binance-xxxxxx
Binance-xxxxxx
`,
    remark: "Enter remark, such as investigation reason...",
    selectRelatedCase: "Select related case",
  },
  buttons: {
    addressRecognize: "Address Recognition",
    hashRecognize: "Hash Recognition",
    identityRecognize: "Identity Recognition",
    generateDocument: "Generate Investigation Document",
    batchImport: "Batch Import",
    downloadTemplate: "Download Template",
  },
  messages: {
    chainRequired: "Chain is required!",
    addSuccess: "Added successfully!",
    uploadExcelOnly: "Only Excel files can be uploaded",
    tagNotSupport: "This tag does not support batch upload",
  },
  validation: {
    institutionTypeRequired: "Institution type is required",
    operationTypeRequired: "Operation type is required",
    priorityRequired: "Priority is required",
    platformRequired: "Institution is required",
    chainRequired: "Chain is required",
  },
  documentfile: {
    title: "Document Preview",
    buttons: {
      download: "Download Investigation Document",
      previous: "Previous",
    },
    preview: "Investigation Document Preview",
    loading: "Loading...",
    info: {
      email: "Investigation Email:",
      emailTitle: "Suggested Email Subject:",
      emailAttachment: "Email Attachment Materials:",
      notes: "Other Notes:",
      none: "None",
    },
    notesList: {
      note1:
        "1. User assets in decentralized wallet service providers cannot be frozen",
      note2:
        "2. The data range and time range should be as clear as possible. It is recommended to retrieve information and operation records for all durations",
      note3:
        "3. It is recommended to clearly request that the data materials returned by the platform be in Excel format. Pictures and PDF formats are strictly prohibited",
      note4:
        "4. It is necessary to require the platform to affix the company's electronic seal for subsequent evidence preservation",
      note5:
        "5. For overseas exchanges, to improve the success rate of investigation, it is recommended to use government mailboxes such as gov.cn to send investigation requests",
    },
    downloadFilename: "Case Evidence Collection Notice",
  },
};
